import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>May your code be bug-free and your dice rolls high.</p>
        <div>
          <a href="#" className="icon">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="#" className="icon">
            <i className="fab fa-github"></i>
          </a>
          <a href="#" className="icon">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
